(() => {
  'use strict';

  if (window.__AKK_VARIANT_PRICE_INITIALIZED__) {
    return;
  }

  window.__AKK_VARIANT_PRICE_INITIALIZED__ = true;

  const ROOT_SELECTOR = '[data-akk-variant-price="true"]';

  /*
   * Becomes true once Minimog has changed the URL using
   * history.pushState() or history.replaceState().
   *
   * From that point onward the URL variant is considered
   * authoritative.
   */
  let historyVariantSyncActive = false;


  /*
   * =========================================================
   * GET VARIANT DATA GENERATED BY LIQUID
   * =========================================================
   */

  function getPriceData(root) {
    const script = root.querySelector(
      '[data-akk-variant-price-data]'
    );

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error(
        'AKK variant price: Invalid variant JSON',
        error
      );

      return null;
    }
  }


  /*
   * =========================================================
   * PRODUCT SCOPE
   * =========================================================
   */

  function getScope(root) {
    return (
      root.closest('.m-main-product--info') ||
      root.closest('product-info') ||
      root.closest('.m-main-product') ||
      root.closest('[id^="shopify-section-"]') ||
      document
    );
  }


  function getScopeFromTarget(target) {
    if (!(target instanceof Element)) {
      return document;
    }

    return (
      target.closest('.m-main-product--info') ||
      target.closest('product-info') ||
      target.closest('.m-main-product') ||
      target.closest('[id^="shopify-section-"]') ||
      document
    );
  }


  /*
   * =========================================================
   * HELPERS
   * =========================================================
   */

  function toggleHidden(element, shouldHide) {
    if (!element) {
      return;
    }

    element.classList.toggle(
      'm:hidden',
      shouldHide
    );
  }


  function setHTML(element, html) {
    if (!element) {
      return;
    }

    element.innerHTML = html || '';
  }


  function isValidVariant(root, variantId) {
    if (!variantId) {
      return false;
    }

    const data = getPriceData(root);

    if (!data || !data.variants) {
      return false;
    }

    return !!data.variants[String(variantId)];
  }


  /*
   * =========================================================
   * UPDATE PRICE COMPONENT
   * =========================================================
   */

  function updatePrice(root, variantId) {
    const data = getPriceData(root);

    if (!data || !data.variants) {
      return false;
    }

    const variant =
      data.variants[String(variantId)];

    if (!variant) {
      console.warn(
        'AKK variant price: Variant not found:',
        variantId
      );

      return false;
    }


    /*
     * Store selected variant
     */

    root.dataset.akkSelectedVariantId =
      String(variant.id);


    /*
     * Sold out state
     */

    root.classList.toggle(
      'm-price--sold-out',
      !variant.available
    );


    /*
     * Compliance sale state
     */

    const isSaleState =
      !!variant.show_reference_price ||
      !!variant.show_sale_badge;

    root.classList.toggle(
      'm-price--on-sale',
      isSaleState
    );


    root.classList.remove(
      'm-price--no-compare'
    );


    /*
     * Debug / compliance attributes
     */

    root.dataset.akkReferencePrice =
      variant.reference_price == null
        ? ''
        : String(
            variant.reference_price
          );


    root.dataset.akkReferencePriceCents =
      variant.reference_price_cents == null
        ? ''
        : String(
            variant.reference_price_cents
          );


    root.dataset.akkComplianceShowCompareAtPrice =
      variant.compliance_show_compare_at_price
        ? 'true'
        : 'false';


    root.dataset.akkComplianceShowSaleBadge =
      variant.compliance_show_sale_badge
        ? 'true'
        : 'false';


    /*
     * =====================================================
     * SELLING PRICE
     * =====================================================
     */

    root
      .querySelectorAll(
        '[data-akk-money-price]'
      )
      .forEach((element) => {

        setHTML(
          element,
          variant.money_price
        );

      });


    /*
     * =====================================================
     * COMPLIANCE REFERENCE PRICE
     * =====================================================
     */

    const referenceWrap =
      root.querySelector(
        '[data-akk-reference-wrap]'
      );


    const referencePrice =
      root.querySelector(
        '[data-akk-reference-price-display]'
      );


    toggleHidden(
      referenceWrap,
      !variant.show_reference_price
    );


    setHTML(
      referencePrice,
      variant.reference_price_money
    );


    /*
     * =====================================================
     * SALE BADGE
     * =====================================================
     */

    const badgeWrap =
      root.querySelector(
        '[data-akk-sale-badge-wrap]'
      );


    const badgeText =
      root.querySelector(
        '[data-akk-sale-badge-text]'
      );


    const isOutlet =
      root.dataset.akkIsOutlet === 'true';

    toggleHidden(
      badgeWrap,
      !variant.show_sale_badge && !isOutlet
    );


    setHTML(
      badgeText,
      variant.badge_html
    );


    /*
     * =====================================================
     * UVP / SHOPIFY COMPARE-AT PRICE
     * =====================================================
     */

    const uvpWrap =
      root.querySelector(
        '[data-akk-uvp-wrap]'
      );


    const uvpPrice =
      root.querySelector(
        '[data-akk-uvp-price]'
      );


    toggleHidden(
      uvpWrap,
      !variant.show_uvp
    );


    setHTML(
      uvpPrice,
      variant.compare_at_money
    );


    /*
     * =====================================================
     * UNIT PRICE
     * =====================================================
     */

    const unitWrap =
      root.querySelector(
        '[data-akk-unit-wrap]'
      );


    const unitPrice =
      root.querySelector(
        '[data-akk-unit-price]'
      );


    const unitBase =
      root.querySelector(
        '[data-akk-unit-base]'
      );


    toggleHidden(
      unitWrap,
      !variant.has_unit_price
    );


    setHTML(
      unitPrice,
      variant.unit_price_money
    );


    if (unitBase) {
      unitBase.textContent =
        variant.unit_base || '';
    }


    /*
     * Custom event in case another custom component
     * needs to react to the price update.
     */

    root.dispatchEvent(
      new CustomEvent(
        'akk:price-updated',
        {
          bubbles: true,

          detail: {
            variantId: variant.id,
            variant: variant
          }
        }
      )
    );


    return true;
  }


  /*
   * =========================================================
   * GET VARIANT FROM SELECTED OPTIONS
   * =========================================================
   */

  function getVariantFromOptions(root) {
    const data = getPriceData(root);

    if (
      !data ||
      !data.variants ||
      !Array.isArray(data.option_names)
    ) {
      return null;
    }


    const scope = getScope(root);

    const selectedValues = {};


    scope
      .querySelectorAll(
        'select[name^="options["], input[name^="options["]:checked'
      )
      .forEach((control) => {

        const name =
          control.getAttribute('name');

        if (!name) {
          return;
        }


        const match =
          name.match(
            /^options\[(.+)\]$/
          );


        if (!match) {
          return;
        }


        selectedValues[match[1]] =
          control.value;

      });


    const selectedOptions =
      data.option_names.map(
        (name) =>
          selectedValues[name]
      );


    if (
      selectedOptions.length === 0 ||
      selectedOptions.some(
        (value) =>
          value === undefined
      )
    ) {
      return null;
    }


    for (
      const [variantId, variant]
      of Object.entries(data.variants)
    ) {

      if (
        !Array.isArray(
          variant.options
        )
      ) {
        continue;
      }


      if (
        variant.options.length !==
        selectedOptions.length
      ) {
        continue;
      }


      const matches =
        variant.options.every(
          (value, index) =>
            String(value) ===
            String(
              selectedOptions[index]
            )
        );


      if (matches) {
        return String(variantId);
      }
    }


    return null;
  }


  /*
   * =========================================================
   * GET VARIANT FROM PRODUCT FORM
   * =========================================================
   */

  function getVariantFromForm(root) {
    const data = getPriceData(root);

    if (
      !data ||
      !data.variants
    ) {
      return null;
    }


    const scope = getScope(root);


    const inputs =
      scope.querySelectorAll(
        [
          'form[action*="/cart/add"] [name="id"]',
          '[data-product-form] [name="id"]',
          'input[name="id"]',
          'select[name="id"]'
        ].join(',')
      );


    for (const input of inputs) {

      const variantId =
        String(
          input.value || ''
        );


      if (
        data.variants[variantId]
      ) {
        return variantId;
      }

    }


    return null;
  }


  /*
   * =========================================================
   * GET VARIANT FROM URL
   * =========================================================
   */

  function getVariantFromURL(root) {
    const data = getPriceData(root);

    if (
      !data ||
      !data.variants
    ) {
      return null;
    }


    const variantId =
      new URL(
        window.location.href
      ).searchParams.get(
        'variant'
      );


    if (
      variantId &&
      data.variants[
        String(variantId)
      ]
    ) {
      return String(variantId);
    }


    return null;
  }


  /*
   * =========================================================
   * RESOLVE CURRENT VARIANT
   * =========================================================
   *
   * IMPORTANT:
   *
   * The old version caused the flickering.
   *
   * It gathered several candidates and deliberately picked
   * whichever one differed from the currently displayed
   * variant.
   *
   * That could produce:
   *
   * URL       = NEW
   * Form      = OLD
   * Options   = NEW
   *
   * displayed = OLD
   * -> choose NEW
   *
   * displayed = NEW
   * -> choose OLD
   *
   * displayed = OLD
   * -> choose NEW
   *
   * etc.
   *
   * We DO NOT do that anymore.
   */

  function resolveVariantId(
    root,
    explicitVariantId
  ) {

    /*
     * Explicit theme event always wins.
     */

    if (
      explicitVariantId &&
      isValidVariant(
        root,
        explicitVariantId
      )
    ) {
      return String(
        explicitVariantId
      );
    }


    /*
     * Once Minimog has demonstrated that it updates the
     * ?variant= URL, treat that URL as authoritative.
     *
     * This prevents an older hidden form input from
     * switching the price back again.
     */

    if (historyVariantSyncActive) {

      const urlVariant =
        getVariantFromURL(root);


      if (urlVariant) {
        return urlVariant;
      }

    }


    /*
     * Before Minimog has updated history, prefer the actual
     * selected option combination.
     */

    const optionVariant =
      getVariantFromOptions(root);


    if (optionVariant) {
      return optionVariant;
    }


    /*
     * Next try Shopify's selected variant ID.
     */

    const formVariant =
      getVariantFromForm(root);


    if (formVariant) {
      return formVariant;
    }


    /*
     * Final fallback: variant in initial URL.
     */

    const urlVariant =
      getVariantFromURL(root);


    if (urlVariant) {
      return urlVariant;
    }


    return null;
  }


  /*
   * =========================================================
   * UPDATE ONE ROOT
   * =========================================================
   */

  function updateRoot(
    root,
    explicitVariantId
  ) {

    const variantId =
      resolveVariantId(
        root,
        explicitVariantId
      );


    if (!variantId) {
      return;
    }


    const currentVariantId =
      String(
        root.dataset
          .akkSelectedVariantId ||
        ''
      );


    /*
     * Already correct.
     */
    if (
      currentVariantId ===
      String(variantId)
    ) {
      return;
    }


    updatePrice(
      root,
      variantId
    );
  }


  /*
   * =========================================================
   * UPDATE ALL PRICE ROOTS IN SCOPE
   * =========================================================
   */

  function updateScope(
    scope,
    explicitVariantId
  ) {

    const actualScope =
      scope instanceof Element ||
      scope instanceof Document
        ? scope
        : document;


    actualScope
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach((root) => {

        updateRoot(
          root,
          explicitVariantId
        );

      });
  }


  /*
   * =========================================================
   * DELAYED CHECKS
   * =========================================================
   *
   * Minimog may resolve a variant over several JS operations.
   *
   * We still check a few times, but because variant source
   * priority is now stable, these checks cannot ping-pong
   * between old and new variants.
   */

  function scheduleUpdate(
    scope,
    explicitVariantId
  ) {

    const delays = [
      0,
      50,
      150,
      300,
      600
    ];


    delays.forEach(
      (delay) => {

        window.setTimeout(
          () => {

            updateScope(
              scope,
              explicitVariantId
            );

          },
          delay
        );

      }
    );
  }


  /*
   * =========================================================
   * NORMAL CHANGE EVENT
   * =========================================================
   */

  document.addEventListener(
    'change',
    (event) => {

      const scope =
        getScopeFromTarget(
          event.target
        );


      if (
        !scope.querySelector(
          ROOT_SELECTOR
        )
      ) {
        return;
      }


      scheduleUpdate(scope);

    }
  );


  /*
   * =========================================================
   * INPUT EVENT
   * =========================================================
   */

  document.addEventListener(
    'input',
    (event) => {

      const scope =
        getScopeFromTarget(
          event.target
        );


      if (
        !scope.querySelector(
          ROOT_SELECTOR
        )
      ) {
        return;
      }


      scheduleUpdate(scope);

    }
  );


  /*
   * =========================================================
   * CLICK EVENT
   * =========================================================
   *
   * Useful for custom Minimog swatches/buttons.
   */

  document.addEventListener(
    'click',
    (event) => {

      const target =
        event.target;


      if (
        !(target instanceof Element)
      ) {
        return;
      }


      const scope =
        getScopeFromTarget(target);


      if (
        !scope.querySelector(
          ROOT_SELECTOR
        )
      ) {
        return;
      }


      scheduleUpdate(scope);

    }
  );


  /*
   * =========================================================
   * COMMON VARIANT EVENTS
   * =========================================================
   */

  const variantEvents = [
    'variant:change',
    'variantChange',
    'variant:changed',

    'product:variant-change',
    'product:variantChange',
    'product:variant-changed',

    'akk:variant-change'
  ];


  variantEvents.forEach(
    (eventName) => {

      document.addEventListener(
        eventName,
        (event) => {

          const detail =
            event.detail || {};


          const explicitVariantId =
            detail.variantId ||
            detail.variant_id ||
            detail.variant?.id ||
            detail.currentVariant?.id ||
            detail.selectedVariant?.id ||
            detail.id ||
            null;


          const scope =
            getScopeFromTarget(
              event.target
            );


          scheduleUpdate(
            scope,
            explicitVariantId
          );

        }
      );

    }
  );


  /*
   * =========================================================
   * MINIMOG HISTORY WATCHER
   * =========================================================
   *
   * Minimog can update:
   *
   * ?variant=123456789
   *
   * via:
   *
   * history.replaceState()
   *
   * That does NOT trigger popstate automatically.
   *
   * We therefore watch pushState/replaceState ourselves.
   */

  function installHistoryWatcher() {

    if (
      window
        .__AKK_HISTORY_WATCHER_INSTALLED__
    ) {
      return;
    }


    window
      .__AKK_HISTORY_WATCHER_INSTALLED__ =
      true;


    const originalPushState =
      window.history.pushState;


    const originalReplaceState =
      window.history.replaceState;


    window.history.pushState =
      function () {

        const result =
          originalPushState.apply(
            this,
            arguments
          );


        historyVariantSyncActive =
          true;


        window.dispatchEvent(
          new Event(
            'akk:history-change'
          )
        );


        return result;
      };


    window.history.replaceState =
      function () {

        const result =
          originalReplaceState.apply(
            this,
            arguments
          );


        historyVariantSyncActive =
          true;


        window.dispatchEvent(
          new Event(
            'akk:history-change'
          )
        );


        return result;
      };

  }


  installHistoryWatcher();


  /*
   * =========================================================
   * MINIMOG CHANGED URL
   * =========================================================
   */

  window.addEventListener(
    'akk:history-change',
    () => {

      /*
       * URL is now authoritative.
       */
      historyVariantSyncActive =
        true;


      scheduleUpdate(
        document
      );

    }
  );


  /*
   * =========================================================
   * BROWSER BACK / FORWARD
   * =========================================================
   */

  window.addEventListener(
    'popstate',
    () => {

      historyVariantSyncActive =
        true;


      scheduleUpdate(
        document
      );

    }
  );


  /*
   * =========================================================
   * INITIAL LOAD
   * =========================================================
   */

  function init() {

    document
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach((root) => {

        const variantId =
          resolveVariantId(root);


        if (variantId) {

          updatePrice(
            root,
            variantId
          );

        }

      });

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );

  } else {

    init();

  }

})();